import { PageBackLink } from "@/components/page-back-link"
import { createFileRoute, Link } from '@tanstack/react-router'

import { PageBreadcrumbs, PageHeader } from '@/components/page-header'

export const Route = createFileRoute('/dashboard/support/chats/')({
  component: SupportChatsPage,
})

function SupportChatsPage() {
  return (
    <div className="space-y-6">
      <PageHeader back={<PageBackLink to="/dashboard/support" label="Back to support" />}
        breadcrumbs={
          <PageBreadcrumbs
            items={[
              <Link key="dashboard" to="/dashboard">Dashboard</Link>,
              <Link key="support" to="/dashboard/support">Support</Link>,
              <span key="chats">Live Chats</span>,
            ]}
          />
        }
        title="Live Chats"
      />
      <div className="rounded-2xl border border-border bg-card shadow-card p-6">
        <p className="font-inter text-body font-normal text-muted-foreground">No live chats available yet. Backend endpoint required.</p>
      </div>
    </div>
  )
}
